module.exports = __webpack_public_path__ + "static/media/qrcodepix.9dea08bb.jpeg";